import React from "react";

const Warn = () => {
  return <div></div>;
};

export default Warn;
